<template>
  <div class="main-content">
    <pulse-loader :loading="loading" :color="loadingColor" class="text-center"/>
    <div class="card" v-if="!loading">
      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <multiselect
              v-model="selected_user"
              :options="records"
              :multiple="false"
              @input="loadHistory"
              label="name"
              track-by="name"
              placeholder="Выберите пользователя"
              select-label="Выбрать"
              deselect-label="Убрать">
              <template slot="singleLabel" slot-scope="props">
                {{ props.option.name }}
                (<span v-for="role in props.option.roles">{{ role.name_title }}</span>)
              </template>
              <!--                  <template slot="option" slot-scope="props">-->
              <!--                    <div>-&#45;&#45;{{ props }}</div>-->
              <!--                  </template>-->
            </multiselect>
            <div class="mt-3">
              <textarea v-model="message" class="form-control" placeholder="Сообщение" rows="5"/>
            </div>
            <div class="text-right mt-2">
              <LoadingButton
                title="Отправить"
                className="btn btn-success mb-1"
                :onClick="sendMessage"
                :loading="btnLoading"
                color="white"
              />
            </div>

          </div>
          <div class="col-md-8">
            <div class="card">
              <div class="card-header">
                История
              </div>
              <div class="card-body">
                <pulse-loader :loading="historyLoading" :color="loadingColor" class="text-center"/>
                <div v-if="!historyLoading && selected_user && selected_user.id">
                  <div>
                    <table class="table table table-sm table-hover">
                      <tbody>
                      <template v-for="dialog in history[selected_user.id].dialogs">
                        <tr>
                          <td width="30px">
                            <i v-bind:class="['icon-fa',
                            {'icon-fa-arrow-circle-right green':  dialog.system_send,
                            'icon-fa-arrow-circle-left blue':!dialog.system_send}]"></i>
                          </td>
                          <td><strong>Диалог:</strong> {{ dialog.text && (dialog.text.text || dialog.text.action) }} ({{ dialog.id }})</td>
                          <td width="90px">{{ moment(dialog.created_at, 'HH:mm DD.MM') }}</td>
                          <td width="30px">
                            <i v-if="!dialog.is_active" class="icon-fa icon-fa-remove gray"></i>
                          </td>
                        </tr>
                        <tr v-for="answer in dialog.answers">
                          <td width="30px">
                            <i v-bind:class="['icon-fa',
                            {'icon-fa-arrow-circle-right green':  answer.system_send,
                            'icon-fa-arrow-circle-left blue':!answer.system_send}]"></i>
                          </td>
                          <td>
                            <div v-html="answer.text && (answer.text.text || answer.text.action)"/>
                          </td>
                          <td width="90px">{{ moment(answer.created_at, 'HH:mm DD.MM') }}</td>
                          <td width="30px">
                            <i v-if="!answer.is_active" class="icon-fa icon-fa-remove gray"></i>
                          </td>
                        </tr>
                      </template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import Multiselect from 'vue-multiselect'
import LoadingButton from "@/components/buttons/LoadingButton";
import moment from "moment";

export default {
  components: {
    Multiselect,
    LoadingButton,
  },
  data() {
    return {
      loadingColor: this.$constants.LOADING_COLOR,
      loading: true,
      records: null,
      selected_user: null,
      message: null,
      btnLoading: false,
      historyLoading: false,
      history: {},
    }
  },
  mounted() {
    this.getUsers();
  },
  methods: {
    async loadHistory() {
      console.log(this.selected_user);
      if (!this.selected_user.id) return;
      // if (!this.selected_user.id || this.history[this.selected_user.id]) return;
      this.historyLoading = true;
      const {data} = await api.index('/telegram/messageHistory?userId=' + this.selected_user.id);
      if (data.success) {
        this.history[this.selected_user.id] = {
          dialogs: data.dialogs,
          messages: data.messages
        }
      } else {
        toastr['warning'](data.message || 'Ошибка сервера');
      }
      this.historyLoading = false;
    },
    async sendMessage() {
      this.btnLoading = true;
      const {data} = await api.post('/telegram/sendMessage', {
        userId: this.selected_user.id,
        message: this.message
      });
      if (data.success) {
        toastr['success']('Отправлено');
      } else {
        toastr['warning'](data.message || 'Ошибка сервера');
      }
      this.btnLoading = false;
    },
    async getUsers() {
      this.loading = true;
      const {data} = await api.index('/users/list');
      if (data.success) {
        const list = data.users.filter((u) => u.is_active);
        this.records = list.reduce((acc, u) => {
          const t = u.details.findIndex((d) => d.alias === 'telegram_chat_data');
          const r = u.roles.findIndex((d) => ['runner', 'chiefRunner'].includes(d.name));
          if (t !== -1 && u.details[t].details.chat_id && r !== -1) {
            acc.push(u);
          }
          return acc;
        }, [])
      } else {
        toastr['warning'](data.message || 'Ошибка сервера');
      }
      this.loading = false;
    },
    moment: function (date, format = 'DD.MM.YYYY') {
      if (!date) return;
      return moment(date).format(format);
    },
  }
}
</script>

<style scoped>
.icon-fa.green {
  color: green;
}

.icon-fa.blue {
  color: blue;
}
</style>
